import React from 'react';

import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';

import {setBackground} from '../../ducks/ui';

import Meta from '../../components/meta/Meta';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import ReviewsList from '../../components/reviews/ReviewsList';
import GoogleReviewsIframe from '../../components/reviews/GoogleReviewsIframe';

@injectIntl
@connect()
export default class ReviewsPage extends React.PureComponent {
  componentDidMount() {
    const {dispatch} = this.props;

    dispatch(setBackground());
  }

  render() {
    const {intl} = this.props;

    return (
      <React.Fragment>
        <Meta
          fallbackTitle={intl.formatMessage({id: 'section.generic.reviews'})}
          alternateSlug='reviews'
        />

        {/* TODO: re-enable once the Google store widget renders on the live domain.
        <GoogleReviewsIframe />
        */}

        <div className="page-info">
          <Breadcrumbs links={[{name: intl.formatMessage({id: 'section.generic.reviews'})}]}/>

          <div className="text-block">
            <h1><FormattedMessage id="section.generic.reviews"/></h1>
          </div>

          <ReviewsList />
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/reviewsPage/ReviewsPage.js